export default __webpack_public_path__ + "static/media/03.da6f1d35.jpg";